import { render } from "./Breeder.vue?vue&type=template&id=94ddd5c4"
import script from "./Breeder.vue?vue&type=script&lang=js"
export * from "./Breeder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__